import {
	Autocomplete,
	AutocompletePropsSizeOverrides,
	TextField,
	Typography
} from '@mui/material';
import { OverridableStringUnion } from '@mui/types';
import { sortBy } from 'lodash';
import React from 'react';

interface IItemsAutocompleteProps<T extends { id: string; name: string }> {
	id: string;
	textLabel: string;
	data: T[];
	onChange: (value: T[]) => void;
	values?: T[];
	multiple: boolean;
	disabled?: boolean;
	size?: OverridableStringUnion<
		'small' | 'medium',
		AutocompletePropsSizeOverrides
	>;
}

const ItemsAutocomplete: React.FC<IItemsAutocompleteProps<any>> = ({
	id,
	data,
	textLabel,
	values,
	multiple,
	onChange,
	disabled,
	...props
}) => {
	const getMore = (more: number) => (
		<Typography
			color="text.secondary"
			variant="body2"
			title={(values || []).map((v) => v.name).join(', ')}
		>
			{`+${more}`}
		</Typography>
	);
	return (
		<Autocomplete
			data-testid={`items-${id}-autocomplete`}
			multiple={multiple}
			limitTags={3}
			fullWidth
			getLimitTagsText={getMore}
			filterSelectedOptions={multiple}
			id={id}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			value={values || []}
			options={sortBy(data || [], (v) => v.name.toLowerCase())}
			getOptionLabel={(option) => option.name}
			disabled={disabled}
			onChange={(_, v) => {
				onChange(v || []);
			}}
			renderInput={(params) => (
				<TextField
					data-testid={`items-${id}-autocomplete-textfield`}
					{...params}
					label={textLabel}
					fullWidth
					disabled={disabled}
				/>
			)}
			{...props}
		/>
	);
};

ItemsAutocomplete.defaultProps = {
	values: undefined,
	disabled: false,
	size: 'medium'
};

export default ItemsAutocomplete;
